module.exports = __webpack_public_path__ + "img/capsulas_blandas.ba132391.jpg";